import React from 'react';
import classNames from 'classnames';

// TODO: [BENTO-12233] Temporarily leaving styles.module.scss to handle grid styles.
// Will need refactor when solution for grid is implemented within new theming strategy
import { getDataActivityMapID } from 'lib/articleUtils';
import styles from './styles.module.scss';

const block = 'listicleProduct';


/**
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {bool} props.isLarge
 * @param {string} props.productName
 */
const Container = ({ children, isLarge, productName }) => {
  const dataActivityMapID = getDataActivityMapID(
    {
      componentName: 'listicle-product',
      pageRegion: 'article-body',
      componentTitle: productName,
    },
  );
  return (
    <div
      className={classNames(
        `${block}`,
        'dn-print ',
        {
          [styles.gridContainerLarge]: isLarge,
          'product__grid-container--large': isLarge,
          'product__grid-container--small': !isLarge,
        },
      )}
      data-activity-map={dataActivityMapID}
      data-testid="product-container"
    >
      <div
        className="product__grid-row"
      >
        {children}
      </div>
    </div>
  );
};

export { Container };
